
import http from '@/utils/http';

export const fetchFollowingUnifiedId: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/IsHasGames',
    // url: '/api/v1/intelligence_pc/following/basic_info',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const fetchFollowingGroups: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/collection/group/list',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const fetchFollowingCurrentGamesMobile: (payload: any, config?: { [key: string]: any }) => Promise<any> = (payload, config) => {
  return http({
    // url: '/api/v1/intelligence_pc/following/new_mobile/current_games',
    ...config,
    url: '/api/v1/intelligence_pc/following/mobile/current_game',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const fetchFollowingCurrentGamesPCConsole: (payload: any, config?: { [key: string]: any }) => Promise<any> = (payload, config) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/following/pconsole/current_game',
    // url: '/api/v1/intelligence_pc/following/pconsole/current_games',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const fetchFollowingCurrentGamesCompany: (payload: any, config?: { [key: string]: any }) => Promise<any> = (payload, config) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/following/new_companies',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const fetchFollowingCurrentGamesMobileTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/new_mobile/current_games/trend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const fetchFollowingCurrentGamesMobileTrendNew: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/mobile/current_game/trend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const fetchFollowingCurrentGamesPCConsoleTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/pconsole/current_games/trends',
    // url: '/api/v1/intelligence_pc/following/pconsole/current_games/trend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const fetchFollowingCurrentGamesCompanyTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/new_companies/trend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const fetchFollowingNewGames: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/new_game',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

export const getGroupList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/collection/group_game/list',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

// 取消关注接口
export const groupDel: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/collection/group/del',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

// 创建关注分组
export const addFollowingGroup: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/collection/group/create',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

// 编辑关注分组
export const editFollowingGroup: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/collection/group/edit',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

// 获取All Games
export const getAllGamesFollowList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/lists',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

// 取消关注接口
export const fetchUnfollowing: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/unfollowing',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

// 复制分组
export const groupCopy: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/collection/group/copy',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

// 收藏分组管理 移动、新增分组
export const relateGamesAndGroups: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/collection/group/move',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
}

// export const getFollowSearchRecord: (payload: any) => Promise<any> = (payload) => {
//   return http({
//     url: '/api/v1/intelligence_pc/following/get_record',
//     method: 'post',
//     data: payload,
//     rawData: true,
//   }) as Promise<any>;
// }

// export const addFollowSearchRecord: (payload: any) => Promise<any> = (payload) => {
//   return http({
//     url: '/api/v1/intelligence_pc/following/post_record',
//     method: 'post',
//     data: payload,
//     rawData: true,
//   }) as Promise<any>;
// }

// export const delFollowSearchRecord: (payload: any) => Promise<any> = (payload) => {
//   return http({
//     url: '/api/v1/intelligence_pc/following/del_record',
//     method: 'post',
//     data: payload,
//     rawData: true,
//   }) as Promise<any>;
// }

export const getFollowingSearch: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/search',
    method: 'post',
    data: {...(payload || {}), Keyword: payload?.search_by_name},
    rawData: true,
  }) as Promise<any>;
}

export const getFollowingShuttleFrameList: (payload:any)=> Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/ShuttleFrame/list',
    method: 'post',
    data: payload,
    // rawData: true,
  }) as Promise<any>;
}


export const createCollectionFollow: (payload:any)=> Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/collection/create',
    method: 'post',
    data: payload,
    // rawData: true,
  }) as Promise<any>;
}

export const getCompareEntityTypeSearch: (payload:any)=> Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/following/compareEntityTypeSearch',
    method: 'post',
    data: payload,
    // rawData: true,
  }) as Promise<any>;
}

export const followSearchPullDown: (payload:any)=> Promise<any> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/searchPullDown',
    method: 'post',
    data: payload,
    // rawData: true,
  }) as Promise<any>;
}

export const getSearchNewList: (payload:any)=> Promise<any> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/searchNewList',
    method: 'post',
    data: payload,
    // rawData: true,
  }) as Promise<any>;
}




